export default __webpack_public_path__ + "static/media/data-broken.0e1d92e6.png";